import { BRAND_WORDMARK_PATHS, BRAND_WORDMARK_VIEWBOX } from './brand-wordmark-data';

export { BRAND_WORDMARK_WIDTH, BRAND_WORDMARK_HEIGHT } from './brand-wordmark-data';

/** One outlined logo for native screens, the website, and offline paper previews. */
export function brandWordmarkSvg(variant: 'color' | 'mono' | 'white' = 'color'): string {
  const paths = BRAND_WORDMARK_PATHS.map((path, index) => {
    const fill =
      variant === 'white' ? '#FFFFFF' : variant === 'color' && index >= 3 ? '#E56858' : '#65435E';
    return `<path fill="${fill}" d="${path}"/>`;
  }).join('');
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${BRAND_WORDMARK_VIEWBOX}" role="img" aria-label="うちのこばこ"><title>うちのこばこ</title>${paths}</svg>`;
}

/** Glyph outlines work inside CSS images without relying on external Japanese fonts. */
export function brandWatermarkTileSvg(): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="360" height="200" viewBox="0 0 360 200" aria-label="うちのこばこ"><g transform="rotate(-22 180 100)" opacity=".48"><svg x="35" y="68" width="290" height="64" viewBox="${BRAND_WORDMARK_VIEWBOX}"><g fill="#65435E" stroke="#FFFFFF" stroke-width="6" stroke-linejoin="round" paint-order="stroke">${BRAND_WORDMARK_PATHS.map((path) => `<path d="${path}"/>`).join('')}</g></svg></g></svg>`;
}
